
export let TIME_ZONES = [
    {
      name: 'Hawaii',
      title: '(GMT-10:00) Hawaii',
      value: '-10'
    },
    {
      name: 'Alaska',
      title: '(GMT-09:00) Alaska',
      value: '-09'
    },
    {
      name: 'Pacific Time (US & Canada)',
      title: '(GMT-08:00) Pacific Time (US & Canada)',
      value: '-08'
    },
    {
      name: 'Arizona',
      title: '(GMT-07:00) Arizona',
      value: '-07'
    },
    {
      name: 'Mountain Time (US & Canada)',
      title: '(GMT-07:00) Mountain Time (US & Canada)',
      value: '-07'
    },
    {
      name: 'Central Time (US & Canada)',
      title: '(GMT-06:00) Central Time (US & Canada)',
      value: '-06'
    },
    {
      name: 'Eastern Time (US & Canada)',
      title: '(GMT-05:00) Eastern Time (US & Canada)',
      value: '-05'
    },
    {
      name: 'Indiana (East)',
      title: '(GMT-05:00) Indiana (East)',
      value: '-05'
    },
    {
      name: 'American Samoa',
      title: '(GMT-11:00) American Samoa',
      value: '-11'
    },
    {
      name: 'International Date Line West',
      title: '(GMT-11:00) International Date Line West',
      value: '-11'
    },
    {
      name: 'Midway Island',
      title: '(GMT-11:00) Midway Island',
      value: '-11'
    },
    {
      name: 'Tijuana',
      title: '(GMT-08:00) Tijuana',
      value: '-08'
    },
    {
      name: 'Chihuahua',
      title: '(GMT-07:00) Chihuahua',
      value: '-07'
    },
    {
      name: 'Mazatlan',
      title: '(GMT-07:00) Mazatlan',
      value: '-07'
    },
    {
      name: 'Central America',
      title: '(GMT-06:00) Central America',
      value: '-06'
    },
    {
      name: 'Guadalajara',
      title: '(GMT-06:00) Guadalajara',
      value: '-06'
    },
    {
      name: 'Mexico City',
      title: '(GMT-06:00) Mexico City',
      value: '-06'
    },
    {
      name: 'Monterrey',
      title: '(GMT-06:00) Monterrey',
      value: '-06'
    },
    {
      name: 'Saskatchewan',
      title: '(GMT-06:00) Saskatchewan',
      value: '-06'
    },
    {
      name: 'Bogota',
      title: '(GMT-05:00) Bogota',
      value: '-05'
    },
    {
      name: 'Lima',
      title: '(GMT-05:00) Lima',
      value: '-05'
    },
    {
      name: 'Quito',
      title: '(GMT-05:00) Quito',
      value: '-05'
    },
    {
      name: 'Atlantic Time (Canada)',
      title: '(GMT-04:00) Atlantic Time (Canada)',
      value: '-04'
    },
    {
      name: 'Caracas',
      title: '(GMT-04:00) Caracas',
      value: '-04'
    },
    {
      name: 'Georgetown',
      title: '(GMT-04:00) Georgetown',
      value: '-04'
    },
    {
      name: 'La Paz',
      title: '(GMT-04:00) La Paz',
      value: '-04'
    },
    {
      name: 'Santiago',
      title: '(GMT-04:00) Santiago',
      value: '-04'
    },
    {
      name: 'Newfoundland',
      title: '(GMT-03:30) Newfoundland',
      value: '-03:30'
    },
    {
      name: 'Brasilia',
      title: '(GMT-03:00) Brasilia',
      value: '-03'
    },
    {
      name: 'Buenos Aires',
      title: '(GMT-03:00) Buenos Aires',
      value: '-03'
    },
    {
      name: 'Greenland',
      title: '(GMT-03:00) Greenland',
      value: '-03'
    },
    {
      name: 'Montevideo',
      title: '(GMT-03:00) Montevideo',
      value: '-03'
    },
    {
      name: 'Mid-Atlantic',
      title: '(GMT-02:00) Mid-Atlantic',
      value: '-02'
    },
    {
      name: 'Azores',
      title: '(GMT-01:00) Azores',
      value: '-01'
    },
    {
      name: 'Cape Verde Is.',
      title: '(GMT-01:00) Cape Verde Is.',
      value: '-01'
    },
    {
      name: 'Edinburgh',
      title: '(GMT+00:00) Edinburgh',
      value: '+00'
    },
    {
      name: 'Lisbon',
      title: '(GMT+00:00) Lisbon',
      value: '+00'
    },
    {
      name: 'London',
      title: '(GMT+00:00) London',
      value: '+00'
    },
    {
      name: 'Monrovia',
      title: '(GMT+00:00) Monrovia',
      value: '+00'
    },
    {
      name: 'UTC',
      title: '(GMT+00:00) UTC',
      value: '+00'
    },
    {
      name: 'Amsterdam',
      title: '(GMT+01:00) Amsterdam',
      value: '+00'
    },
    {
      name: 'Belgrade',
      title: '(GMT+01:00) Belgrade',
      value: '+01'
    },
    {
      name: 'Berlin',
      title: '(GMT+01:00) Berlin',
      value: '+01'
    },
    {
      name: 'Bern',
      title: '(GMT+01:00) Bern',
      value: '+01'
    },
    {
      name: 'Bratislava',
      title: '(GMT+01:00) Bratislava',
      value: '+01'
    },
    {
      name: 'Brussels',
      title: '(GMT+01:00) Brussels',
      value: '+01'
    },
    {
      name: 'Budapest',
      title: '(GMT+01:00) Budapest',
      value: '+01'
    },
    {
      name: 'Casablanca',
      title: '(GMT+01:00) Casablanca',
      value: '+01'
    },
    {
      name: 'Copenhagen',
      title: '(GMT+01:00) Copenhagen',
      value: '+01'
    },
    {
      name: 'Dublin',
      title: '(GMT+01:00) Dublin',
      value: '+01'
    },
    {
      name: 'Ljubljana',
      title: '(GMT+01:00) Ljubljana',
      value: '+01'
    },
    {
      name: 'Madrid',
      title: '(GMT+01:00) Madrid',
      value: '+01'
    },
    {
      name: 'Paris',
      title: '(GMT+01:00) Paris',
      value: '+01'
    },
    {
      name: 'Prague',
      title: '(GMT+01:00) Prague',
      value: '+01'
    },
    {
      name: 'Rome',
      title: '(GMT+01:00) Rome',
      value: '+01'
    },
    {
      name: 'Sarajevo',
      title: '(GMT+01:00) Sarajevo',
      value: '+01'
    },
    {
      name: 'Skopje',
      title: '(GMT+01:00) Skopje',
      value: '+01'
    },
    {
      name: 'Stockholm',
      title: '(GMT+01:00) Stockholm',
      value: '+01'
    },
    {
      name: 'Vienna',
      title: '(GMT+01:00) Vienna',
      value: '+01'
    },
    {
      name: 'Warsaw',
      title: '(GMT+01:00) Warsaw',
      value: '+01'
    },
    {
      name: 'West Central Africa',
      title: '(GMT+01:00) West Central Africa',
      value: '+01'
    },
    {
      name: 'Zagreb',
      title: '(GMT+01:00) Zagreb',
      value: '+01'
    },
    {
      name: 'Athens',
      title: '(GMT+02:00) Athens',
      value: '+02'
    },
    {
      name: 'Bucharest',
      title: '(GMT+02:00) Bucharest',
      value: '+02'
    },
    {
      name: 'Cairo',
      title: '(GMT+02:00) Cairo',
      value: '+02'
    },
    {
      name: 'Harare',
      title: '(GMT+02:00) Harare',
      value: '+02'
    },
    {
      name: 'Helsinki',
      title: '(GMT+02:00) Helsinki',
      value: '+02'
    },
    {
      name: 'Jerusalem',
      title: '(GMT+02:00) Jerusalem',
      value: '+02'
  
    },
    {
      name: 'Kaliningrad',
      title: '(GMT+02:00) Kaliningrad',
      value: '+02'
    },
    {
      name: 'Kyiv',
      title: '(GMT+02:00) Kyiv',
      value: '+02'
    },
    {
      name: 'Pretoria',
      title: '(GMT+02:00) Pretoria',
      value: '+02'
    },
    {
      name: 'Riga',
      title: '(GMT+02:00) Riga',
      value: '+02'
    },
    {
      name: 'Sofia',
      title: '(GMT+02:00) Sofia',
      value: '+02'
    },
    {
      name: 'Tallinn',
      title: '(GMT+02:00) Tallinn',
      value: '+02'
    },
    {
      name: 'Vilnius',
      title: '(GMT+02:00) Vilnius',
      value: '+02'
    },
    {
      name: 'Baghdad',
      title: '(GMT+03:00) Baghdad',
      value: '+03'
    },
    {
      name: 'Istanbul',
      title: '(GMT+03:00) Istanbul',
      value: '+03'
    },
    {
      name: 'Kuwait',
      title: '(GMT+03:00) Kuwait',
      value: '+03'
    },
    {
      name: 'Minsk',
      title: '(GMT+03:00) Minsk',
      value: '+03'
    },
    {
      name: 'Moscow',
      title: '(GMT+03:00) Moscow',
      value: '+03'
    },
    {
      name: 'Nairobi',
      title: '(GMT+03:00) Nairobi',
      value: '+03'
    },
    {
      name: 'Riyadh',
      title: '(GMT+03:00) Riyadh',
      value: '+03'
    },
    {
      name: 'St. Petersburg',
      title: '(GMT+03:00) St. Petersburg',
      value: '+03'
    },
    {
      name: 'Tehran',
      title: '(GMT+03:30) Tehran',
      value: '+03:30'
    },
    {
      name: 'Abu Dhabi',
      title: '(GMT+04:00) Abu Dhabi',
      value: '+04'
    },
    {
      name: 'Baku',
      title: '(GMT+04:00) Baku',
      value: '+04'
    },
    {
      name: 'Muscat',
      title: '(GMT+04:00) Muscat',
      value: '+04'
    },
    {
      name: 'Samara',
      title: '(GMT+04:00) Samara',
      value: '+04'
    },
    {
      name: 'Tbilisi',
      title: '(GMT+04:00) Tbilisi',
      value: '+04'
    },
    {
      name: 'Volgograd',
      title: '(GMT+04:00) Volgograd',
      value: '+04'
    },
    {
      name: 'Yerevan',
      title: '(GMT+04:00) Yerevan',
      value: '+04'
    },
    {
      name: 'Kabul',
      title: '(GMT+04:30) Kabul',
      value: '+04:30'
    },
    {
      name: 'Ekaterinburg',
      title: '(GMT+05:00) Ekaterinburg',
      value: '+05'
    },
    {
      name: 'Islamabad',
      title: '(GMT+05:00) Islamabad',
      value: '+05'
    },
    {
      name: 'Karachi',
      title: '(GMT+05:00) Karachi',
      value: '+05'
    },
    {
      name: 'Tashkent',
      title: '(GMT+05:00) Tashkent',
      value: '+05'
    },
    {
      name: 'Chennai',
      title: '(GMT+05:30) Chennai',
      value: '+05:30'
    },
    {
      name: 'Kolkata',
      title: '(GMT+05:30) Kolkata',
      value: '+05:30'
    },
    {
      name: 'Mumbai',
      title: '(GMT+05:30) Mumbai',
      value: '+05:30'
    },
    {
      name: 'New Delhi',
      title: '(GMT+05:30) New Delhi',
      value: '+05:30'
    },
    {
      name: 'Sri Jayawardenepura',
      title: '(GMT+05:30) Sri Jayawardenepura',
      value: '+05:30'
    },
    {
      name: 'Kathmandu',
      title: '(GMT+05:45) Kathmandu',
      value: '+05:45'
    },
    {
      name: 'Almaty',
      title: '(GMT+06:00) Almaty',
      value: '+06'
    },
    {
      name: 'Astana',
      title: '(GMT+06:00) Astana',
      value: '+06'
    },
    {
      name: 'Dhaka',
      title: '(GMT+06:00) Dhaka',
      value: '+06'
    },
    {
      name: 'Urumqi',
      title: '(GMT+06:00) Urumqi',
      value: '+06'
    },
    {
      name: 'Rangoon',
      title: '(GMT+06:30) Rangoon',
      value: '+06'
    },
    {
      name: 'Bangkok',
      title: '(GMT+07:00) Bangkok',
      value: '+07'
    },
    {
      name: 'Hanoi',
      title: '(GMT+07:00) Hanoi',
      value: '+07'
    },
    {
      name: 'Jakarta',
      title: '(GMT+07:00) Jakarta',
      value: '+07'
    },
    {
      name: 'Krasnoyarsk',
      title: '(GMT+07:00) Krasnoyarsk',
      value: '+07'
    },
    {
      name: 'Novosibirsk',
      title: '(GMT+07:00) Novosibirsk',
      value: '+07'
    },
    {
      name: 'Beijing',
      title: '(GMT+08:00) Beijing',
      value: '+08'
    },
    {
      name: 'Chongqing',
      title: '(GMT+08:00) Chongqing',
      value: '+08'
    },
    {
      name: 'Hong Kong',
      title: '(GMT+08:00) Hong Kong',
      value: '+08'
    },
    {
      name: 'Irkutsk',
      title: '(GMT+08:00) Irkutsk',
      value: '+08'
    },
    {
      name: 'Kuala Lumpur',
      title: '(GMT+08:00) Kuala Lumpur',
      value: '+08'
    },
    {
      name: 'Perth',
      title: '(GMT+08:00) Perth',
      value: '+08'
    },
    {
      name: 'Singapore',
      title: '(GMT+08:00) Singapore',
      value: '+08'
    },
    {
      name: 'Taipei',
      title: '(GMT+08:00) Taipei',
      value: '+08'
    },
    {
      name: 'Ulaanbaatar',
      title: '(GMT+08:00) Ulaanbaatar',
      value: '+08'
    },
    {
      name: 'Osaka',
      title: '(GMT+09:00) Osaka',
      value: '+09'
    },
    {
      name: 'Sapporo',
      title: '(GMT+09:00) Sapporo',
      value: '+09'
    },
    {
      name: 'Seoul',
      title: '(GMT+09:00) Seoul',
      value: '+09'
    },
    {
      name: 'Tokyo',
      title: '(GMT+09:00) Tokyo',
      value: '+09'
    },
    {
      name: 'Yakutsk',
      title: '(GMT+09:00) Yakutsk',
      value: '+09'
    },
    {
      name: 'Adelaide',
      title: '(GMT+09:30) Adelaide',
      value: '+09:30'
    },
    {
      name: 'Darwin',
      title: '(GMT+09:30) Darwin',
      value: '+09:30'
    },
    {
      name: 'Brisbane',
      title: '(GMT+10:00) Brisbane',
      value: '+10'
    },
    {
      name: 'Canberra',
      title: '(GMT+10:00) Canberra',
      value: '10'
    },
    {
      name: 'Guam',
      title: '(GMT+10:00) Guam',
      value: '+10'
    },
    {
      name: 'Hobart',
      title: '(GMT+10:00) Hobart',
      value: '+10'
    },
    {
      name: 'Melbourne',
      title: '(GMT+10:00) Melbourne',
      value: '+10'
    },
    {
      name: 'Port Moresby',
      title: '(GMT+10:00) Port Moresby',
      value: '+10'
    },
    {
      name: 'Sydney',
      title: '(GMT+10:00) Sydney',
      value: '+10'
    },
    {
      name: 'Vladivostok',
      title: '(GMT+10:00) Vladivostok',
      value: '+10'
    },
    {
      name: 'Magadan',
      title: '(GMT+11:00) Magadan',
      value: '+11'
    },
    {
      name: 'New Caledonia',
      title: '(GMT+11:00) New Caledonia',
      value: '+11'
    },
    {
      name: 'Solomon Is.',
      title: '(GMT+11:00) Solomon Is.',
      value: '+11'
    },
    {
      name: 'Srednekolymsk',
      title: '(GMT+11:00) Srednekolymsk',
      value: '+11'
    },
    {
      name: 'Auckland',
      title: '(GMT+12:00) Auckland',
      value: '12'
    },
    {
      name: 'Fiji',
      title: '(GMT+12:00) Fiji',
      value: '+12'
    },
    {
      name: 'Kamchatka',
      title: '(GMT+12:00) Kamchatka',
      value: '+12'
    },
    {
      name: 'Marshall Is.',
      title: '(GMT+12:00) Marshall Is.',
      value: '+12'
    },
    {
      name: 'Wellington',
      title: '(GMT+12:00) Wellington',
      value: '+12'
    },
    {
      name: 'Chatham Is.',
      title: '(GMT+12:45) Chatham Is.',
      value: '+12:45'
    },
    {
      name: 'Nuku&#39;alofa',
      title: '(GMT+13:00) Nuku&#39;alofa',
      value: '+13'
    },
    {
      name: 'Samoa',
      title: '(GMT+13:00) Samoa',
      value: '+13'
    },
    {
      name: 'Tokelau Is.',
      title: '(GMT+13:00) Tokelau Is.',
      value: '+13'
    }
  ]
  
  export const WEEK_SERIES = [
    { key: 7, value: false, label: "Sun" },
    { key: 1, value: true, label: "Mon" },
    { key: 2, value: true, label: "Tue" },
    { key: 3, value: true, label: "Wed" },
    { key: 4, value: true, label: "Thu" },
    { key: 5, value: true, label: "Fri" },
    { key: 6, value: false, label: "Sat" },
  ];

  export const SUPPORT_MESSAGE = `Unexpected error! please try again or <a href="mailto:support@lollylaw.com">contact support</a> for further assistance`